<div class="flex-container" style="height: 100%">
  <vl-widget-title
    [text]="'stats.ca_par_periode' | trans"
    [widget]="widget()"
    [draggable]="false"
    [editable]="false"
    [filter]="true"
  >
    <ng-content class="drag-handler" select=".drag-handler"></ng-content>

    <!-- Bouton filtre dans le header -->
    <ng-content class="filter" select=".filter">
      <vl-chips
        size="small"
        iconLeft="settings"
        (action)="trigger.attachOverlay()"
        [popoverTrigger]="filters"
        #trigger="popoverElement"
        [closeOnClickOutside]="true"
        state="enabled"
      >
        {{ 'button.filter' | trans }}
      </vl-chips>
    </ng-content>
  </vl-widget-title>

  <!-- Popover filtres -->
  <ng-template #filters>
    <div class="flex-col w100 gap-8 justup-card p-8 up-3">
      <div class="caption on-background">Période</div>
      <vl-chips-toggle
        [(value)]="timeScale"
        [elements]="timeScaleChoices"
      ></vl-chips-toggle>
    </div>
  </ng-template>

  @if (metadata()?.loading) {
    <div class="overflow-hidden widget-content">
      <div class="flex-row gap-32 align-end">
        <ngx-skeleton-loader count="1"
                             [theme]="{'height': '200px', 'width': '70px', 'background-color': 'var(--color-on-disabled)'}"/>
        <ngx-skeleton-loader count="1"
                             [theme]="{'height': '140px', 'width': '70px', 'background-color': 'var(--color-on-disabled)'}"/>
        <ngx-skeleton-loader count="1"
                             [theme]="{'height': '220px', 'width': '70px', 'background-color': 'var(--color-on-disabled)'}"/>
        <ngx-skeleton-loader count="1"
                             [theme]="{'height': '110px', 'width': '70px', 'background-color': 'var(--color-on-disabled)'}"/>
        <ngx-skeleton-loader count="1"
                             [theme]="{'height': '90px', 'width': '70px', 'background-color': 'var(--color-on-disabled)'}"/>
        <ngx-skeleton-loader count="1"
                             [theme]="{'height': '30px', 'width': '70px', 'background-color': 'var(--color-on-disabled)'}"/>
      </div>
    </div>
  } @else {
    @if (labels().length) {
      <div class="widget-content fade-in">
        <canvas class="w100 h100" #caperiode></canvas>
      </div>
    } @else {
      <div class="widget-content empty">
        <div class="caption on-disabled">{{ 'filters.no_data' | trans }}</div>
      </div>
    }
  }
</div>
